module.exports = __webpack_public_path__ + "img/makes.371057ba.png";